import { MsalProvider } from '@azure/msal-react';
import { useEffect, useState } from 'react';

import { msalInstance } from '~lib/auth/msal-config';

import { TooltipProvider } from '~ui/base/tooltip';

import { AppRoot } from '~navigation/roots/app-root';
import { DatasetsPage } from '~navigation/pages/datasets-page';

import '~styles/globals.css';

// MSAL must call `initialize()` once before any other API. We render nothing
// until that resolves to avoid a flash of unauthenticated state.
function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    msalInstance
      .initialize()
      .then(() => msalInstance.handleRedirectPromise())
      .then(() => {
        const account = msalInstance.getAllAccounts()[0];
        if (account) msalInstance.setActiveAccount(account);
        setReady(true);
      })
      .catch((error) => {
        console.error('MSAL initialization failed', error);
        setReady(true);
      });
  }, []);

  if (!ready) return null;

  return (
    <MsalProvider instance={msalInstance}>
      <TooltipProvider delayDuration={300} skipDelayDuration={500}>
        <AppRoot>
          <DatasetsPage />
        </AppRoot>
      </TooltipProvider>
    </MsalProvider>
  );
}

export { App };
